var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _g3, _g4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeepBreathing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 144,
    viewBox: "0 0 267 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 97C87.6995 97 68 77.3005 68 53C68 28.6995 87.6995 9 112 9C136.301 9 156 28.6995 156 53C156 77.3005 136.301 97 112 97Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 139C135.699 139 116 119.301 116 95C116 70.6995 135.699 51 160 51C184.301 51 204 70.6995 204 95C204 119.301 184.301 139 160 139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 101C123.49 101 102 79.5097 102 53C102 26.4903 123.49 5 150 5C176.51 5 198 26.4903 198 53C198 79.5097 176.51 101 150 101Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115 140C86.2812 140 63 116.719 63 88C63 59.2812 86.2812 36 115 36C143.719 36 167 59.2812 167 88C167 116.719 143.719 140 115 140Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 267 130)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 41 138)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 70)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 55 1)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 228 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 247 64)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10819_8345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136 125C164.719 125 188 101.719 188 73C188 44.2812 164.719 21 136 21C107.281 21 84 44.2812 84 73C84 101.719 107.281 125 136 125Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 55V55C152 59.4183 148.418 63 144 63V63C139.582 63 136 59.4183 136 55V47",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 55V55C120 59.4183 123.582 63 128 63V63C132.418 63 136 59.4183 136 55V47",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 82C104 76.5 107.999 49 124.494 49C131.492 49 130.992 67.2085 130.992 75C130.992 88 128 95 110.998 95C105 95 104 87.5 104 82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 82C168 76.5 164.001 49 147.506 49C140.508 49 141.008 67.2085 141.008 75C141.008 88 144 95 161.002 95C167 95 168 87.5 168 82Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10819_8345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.326 58.941C195.548 59.8656 207.017 49.8962 207.941 36.6736C208.866 23.4511 198.897 11.9826 185.674 11.0579C172.451 10.1333 160.983 20.1028 160.058 33.3253C159.134 46.5479 169.103 58.0164 182.326 58.941Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.946 27.2273V27.2273C191.803 29.2615 190.039 30.7953 188.005 30.653V30.653C185.97 30.5108 184.437 28.7464 184.579 26.7121L184.836 23.0288",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.213 26.197V26.197C177.071 28.2312 178.605 29.9956 180.639 30.1379V30.1379C182.673 30.2801 184.438 28.7463 184.58 26.7121L184.837 23.0288",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.977 38.1126C169.154 35.5803 171.88 23.0477 179.475 23.5788C182.697 23.8041 181.88 32.1714 181.63 35.7587C181.211 41.7441 179.608 44.8707 171.78 44.3233C169.018 44.1302 168.8 40.6449 168.977 38.1126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.443 40.1732C198.62 37.6409 197.665 24.8507 190.07 24.3197C186.848 24.0944 186.492 32.4939 186.241 36.0812C185.823 42.0666 186.975 45.3859 194.803 45.9332C197.564 46.1263 198.266 42.7054 198.443 40.1732Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10819_8345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0465 59.9737C75.0771 59.3956 83.5505 49.9849 82.9724 38.9543C82.3943 27.9238 72.9836 19.4504 61.9531 20.0285C50.9225 20.6066 42.4491 30.0172 43.0272 41.0478C43.6053 52.0783 53.0159 60.5517 64.0465 59.9737Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7831 32.7651V32.7651C68.872 34.4621 67.5684 35.9099 65.8714 35.9988V35.9988C64.1744 36.0878 62.7266 34.7842 62.6377 33.0872L62.4767 30.0145",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4921 33.4096V33.4096C56.581 35.1066 58.0288 36.4102 59.7258 36.3213V36.3213C61.4228 36.2324 62.7264 34.7846 62.6375 33.0876L62.4765 30.0148",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8908 44.1007C50.7801 41.9882 51.7625 31.3453 58.098 31.0133C60.7859 30.8724 60.9605 37.8761 61.1173 40.8687C61.379 45.8619 60.3706 48.6107 53.8403 48.953C51.5366 49.0737 51.0015 46.2132 50.8908 44.1007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4709 42.8126C75.3602 40.7001 73.2707 30.2182 66.9352 30.5502C64.2473 30.6911 64.8058 37.6747 64.9626 40.6673C65.2243 45.6605 66.5145 48.2889 73.0447 47.9466C75.3485 47.8259 75.5816 44.9251 75.4709 42.8126Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10819_8345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.258 141.924C215.262 142.887 224.962 134.747 225.925 123.743C226.888 112.739 218.748 103.039 207.744 102.076C196.741 101.113 187.04 109.253 186.077 120.257C185.115 131.261 193.254 140.961 204.258 141.924Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.735 115.639V115.639C212.587 117.332 211.094 118.585 209.401 118.436V118.436C207.709 118.288 206.456 116.796 206.604 115.103L206.873 112.038",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.474 114.567V114.567C200.326 116.26 201.578 117.752 203.271 117.901V117.901C204.964 118.049 206.456 116.796 206.604 115.104L206.873 112.038",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.439 124.374C193.623 122.267 196.077 111.865 202.397 112.417C205.079 112.652 204.277 119.612 204.015 122.597C203.58 127.578 202.199 130.16 195.684 129.59C193.386 129.389 193.254 126.482 193.439 124.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.96 126.52C218.145 124.413 217.534 113.742 211.214 113.189C208.533 112.954 208.114 119.948 207.853 122.933C207.417 127.914 208.329 130.696 214.843 131.266C217.141 131.467 217.776 128.627 217.96 126.52Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.5 22.5L250.5 18",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231 88.5L247.5 92",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16L19.5 21.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 111L41.5 106.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10819_8345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 21,
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10819_8345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.732,
    y: 9.38379,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(4 161.732 9.38379)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10819_8345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.9805,
    y: 21.0752,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-3 41.9805 21.0752)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10819_8345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.82,
    y: 100.333,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(5 187.82 100.333)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepBreathing);
export default __webpack_public_path__ + "static/media/deep-breathing.1e216ee950986c63307cd80b09778ea4.svg";
export { ForwardRef as ReactComponent };